import React, { ReactElement } from "react";

import Button from "../../button";

import {
  sessionTimeoutOverlayCSS,
  sessionTimeoutOverlayContentCSS,
} from "./SessionTimeoutModal.styles";
import { ButtonSize } from "../../types";
import Modal from "../../modal";
import { SessionTimeoutModalProps } from "./SessionTimeoutModal.types";

export const SessionTimeoutModal = ({
  redirectionUrl = "/",
  isSessionTimeoutModalOpen,
  resetState,
  isFullScreen,
  setIsSessionTimeoutModalOpen,
  sessionExpiredLabel = "Session expired",
  modalContent = "You can start a new chat or close this window",
  startNewChatButtonLabel = "Start new chat",
}: SessionTimeoutModalProps): ReactElement | null => {
  if (!isFullScreen && !isSessionTimeoutModalOpen) {
    return null;
  }

  const renderModalContent = (
    <>
      <p>{modalContent}</p>
      <nav className="spark-btn-group">
        <Button
          className={`spark-btn-group-primary ${
            !isFullScreen ? "spark-full-width" : ""
          }`}
          size={ButtonSize.SMALL}
          onClick={(e): void => {
            e.preventDefault();
            setIsSessionTimeoutModalOpen(false);
            setTimeout(resetState, 100);
            window.open(redirectionUrl, "_blank");
          }}
        >
          {startNewChatButtonLabel}
        </Button>
      </nav>
    </>
  );

  return isFullScreen ? (
    <Modal
      onClose={(): void => {
        setIsSessionTimeoutModalOpen(false);
        setTimeout(resetState, 100);
        window.close();
      }}
      open={isSessionTimeoutModalOpen}
      title={sessionExpiredLabel}
      disableBackdropClick={true}
    >
      {renderModalContent}
    </Modal>
  ) : (
    <div className={sessionTimeoutOverlayCSS}>
      <div className={sessionTimeoutOverlayContentCSS}>
        <h2>{sessionExpiredLabel}</h2>
        {renderModalContent}
      </div>
    </div>
  );
};
